import { useState } from "react";
import secondaryComponents from "../../../components/secondaryComponents";
import primaryComponents from "../../../components/primaryComponents";
import { useNavigate, useParams } from "react-router-dom";
import { pathConstants } from "../../../routes/pathContants";
import Orderflows from "../../../components/secondaryComponents/StoreCheckout/Orderflows";
import { ReturnIcon } from "../../../assets/svgIcons";

export const OrderExtra = () => {
  const navigate = useNavigate();
  const { store_id, order_id } = useParams();
  const [isReturnStock, setIsReturnStock] = useState(false);

  return (
    <secondaryComponents.Modal
      isActive={true}
      width={1300}
      padding={"0px"}
      style={{ maxHeight: "100%", height: "100vh", borderRadius: "0" }}
      closeModal={() =>
        navigate(pathConstants.SELL_MODE({ store_id: store_id }))
      }
    >
      <Orderflows
        orderId={order_id}
        closeModal={() =>
          navigate(pathConstants.SELL_MODE({ store_id: store_id }))
        }
        isViaBill={false}
        viaSellMode={true}
        defaultLanding={"tnxReceipt"}
        headerExtra={
          <secondaryComponents.NavigateWithPermission
            permissionParentKey={"Inventory Management"}
            permissionChildKey="can_return_products"
          >
            <primaryComponents.Button
              classNames={"btn btn--orange smallBtn"}
              onClick={() => setIsReturnStock(true)}
              style={{ padding: "0 10px" }}
            >
              <ReturnIcon width="18" height="18" />
              <span className="ml-1">Return</span>
            </primaryComponents.Button>
          </secondaryComponents.NavigateWithPermission>
        }
      />

      <secondaryComponents.SideModal
        width={700}
        isActive={isReturnStock}
        closeModal={() => setIsReturnStock(false)}
      >
        <secondaryComponents.ReturnStockWidget
          closeWidget={() => setIsReturnStock(false)}
          defaultOrderId={order_id}
        />
      </secondaryComponents.SideModal>
    </secondaryComponents.Modal>
  );
};
